import React, { PureComponent } from "react"

/* Constants */
import { utils } from "../constants"


/* Component Give Up */
class GiveUp extends PureComponent {

    render = () => {

        const { onClick } = this.props
        return (
            <div onClick={() => onClick()} className="game-button give-up-button">{utils.translate("GIVE UP")}</div>
        )
    }

}

export default GiveUp